export const articlesArray = [	
	{ 
        source: "Medium",
        date: "2020-07-07",
        tags: ["Accesibilidad", "Accesibility", "Aria", "Web development", "Front End Development"],
        lang: "en",
        title: "A Developer’s Nightmare: Web Accessibility",
        href: "https://medium.com/@marasalazar/developers-nightmare-web-accessibility-52b9a6890403"
    },
	{ 
        source: "Medium",
        date: "2020-06-28",
        lang: "en",
        title: "Why, Icomoon, why?",
        href: "https://medium.com/@marasalazar/why-icomoon-why-15c2d78ec96e" 
    },
	{ 
        source: "Medium",
        date: "2020-07-10",
        tags: ["Vue", "Vuejs", "Tailwind", "Atomic Design", "CSS"],
        lang: "en",
        title: "How to Structure CSS in Vue Like a Pro",
        href: "https://marasalazar.medium.com/how-to-structure-css-in-vue-like-a-pro-5475749cf5ea" 
    },
	{ 
        source: "Medium",
        date: "2020-07-14",
        tags: ["Internet Explorer", "ie11", "ie11Compatibility"],
        lang: "es",
        title: "Cómo dar soporte a IE y no morir en el intento",
        href: "https://marasalazar.medium.com/c%C3%B3mo-dar-soporte-a-ie-y-no-morir-en-el-intento-7049dcbbf43f" 
    },
	{ 
        source: "Medium",
        date: "2020-20-26",
        tags: ["Angular", "Angular Material", "Accesibility"],
        lang: "en",
        title: "To Angular Material or not to Angular Material?",
        href: "https://marasalazar.medium.com/to-angular-material-or-not-to-angular-material-940a616ac22d" 
    },      
];

export const othersArray = [
    { 
        source: "weAAAre",
        date: "2026-11-01",
        tags: ["events", "Accesibility", "culture"],
        lang: "es",
        title: "Las cosas que nadie te cuenta sobre organizar un evento accesible",
        href: "https://weaaare.com/blog/organizar-evento-accesible" 
    },
    { 
        source: "Manfred",
        date: "2026-05-14",
        tags: ["role", "Accesibility", "culture"],
        lang: "es",
        title: "Cómo introducir accesibilidad en un equipo que nunca ha pensado en ella",
        href: "https://www.getmanfred.com/blog/como-introducir-accesibilidad-en-un-equipo-que-nunca-ha-pensado-en-ella" 
    },
    { 
        source: "weAAAre",
        date: "2026-26-04",
        tags: ["Accesibility", "mentorship", "soft skills", "neurodivergence"],
        lang: "es",
        title: "El día que me di cuenta que mi mentoría no era accesible",
        href: "https://www.weaaare.com/blog/mentoria-accesible" 
    },
    { 
        source: "weAAAre",
        date: "2026-03-05",
        tags: ["role", "ARIA", "Accesibility", "HTML"],
        lang: "es",
        title: "Cuando HTML se queda corto: roles de ARIA",
        href: "https://www.weaaare.com/blog/html-se-queda-corto-roles-de-aria" 
    }, 
 
]